import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'

import { SentryUserContext } from '@nebula/shared/components'
import { isChunkLoadErrorEvent, resolveSentryConfig } from '@nebula/shared/utils'

import App from './App'

import './index.css'

// DSN e `environment` saem de env var com fallback — ver `shared/utils/sentryConfig.ts`
// (issue #748: este app já resolvia os dois inline; a regra passou a valer para os cinco,
// numa cópia só).
const sentry = resolveSentryConfig(import.meta.env)

// O drop de eventos de `localhost` que existia aqui saiu com a #748: ele era o
// paliativo local do defeito que o `environment` resolve de vez. A decisão da issue é
// manter dev REPORTANDO — dev quebrado às vezes é informação útil —, e filtrar na fila
// do Sentry pelo campo, que agora chega preenchido. Mantê-lo deixaria este app como o
// único dos cinco sem telemetria de desenvolvimento, sem que nada mais o distinga.
Sentry.init({
  dsn: sentry.dsn,
  environment: sentry.environment,
  enabled: sentry.enabled,
  sendDefaultPii: true,
  beforeSend(event) {
    if (isChunkLoadErrorEvent(event)) return null
    return event
  },
  initialScope: {
    tags: { app: 'nebula-rs' },
  },
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <SentryUserContext />
        <App />
        <Toaster position="top-right" richColors />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
